import useCategories from '../../../hooks/useCategories';
import { Root, SubTitle, Title } from './CategoryDetailsStyle';
import { SHOW_CATEGORY_CONTENT } from '../../../constants/categories';
import { useEffect, useRef } from 'react';

interface CategoryDetailsProps {
  slug?: string;
}

function CategoryDetails({ slug }: CategoryDetailsProps) {
  const { category, getSolutionGroup } = useCategories(slug);

  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (category && slug && rootRef.current) {
      const parent = rootRef.current.parentElement?.parentElement;
      parent?.classList.add(SHOW_CATEGORY_CONTENT);
    }
  }, [category, slug]);

  if (!slug) {
    return null;
  }

  return (
    <Root ref={rootRef}>
      <SubTitle>{getSolutionGroup(slug)?.name ?? ''}</SubTitle>
      <Title as={'h3'}>{category?.name}</Title>
    </Root>
  );
}

export default CategoryDetails;
